export const JORNADA_LIST_REQUEST = "JORNADA_LIST_REQUEST";
export const JORNADA_LIST_SUCCESS = "JORNADA_LIST_SUCCESS";
export const JORNADA_LIST_FAIL = "JORNADA_LIST_FAIL";

export const JORNADA_MATCHES_LIST_REQUEST = "JORNADA_MATCHES_LIST_REQUEST";
export const JORNADA_MATCHES_LIST_SUCCESS = "JORNADA_MATCHES_LIST_SUCCESS";
export const JORNADA_MATCHES_LIST_FAIL = "JORNADA_MATCHES_LIST_FAIL";
